<template>
    <div>
        <div class="row mb-4 p-0" style="width: 50rem; margin: 0 auto;">
            <div class="col-md-6 p-0 m-0">
                <button class="btn btn-outline-primary rounded-full float-left"
                        @click="backToProposal()">
                    Back to proposal
                </button>
            </div>
            <div class="col-md-6 p-0 m-0">
                <button class="btn btn-outline-primary rounded-full float-right"
                        @click="sendForSigning()">
                    Send
                </button>
            </div>
        </div>
        <div>
            <div class="h-100 w-100 row align-items-center m-0">
                <div class="card bg-white shadow" style="margin: 0 auto;">
                    <div style="width: 50rem;overflow: hidden;">
                        <div class="p-4 overflow-hidden">
                            <h6>Send document</h6>
                            <div class="col-md-12 p-0 mt-4 text-muted" style="font-size: 14px;">
                                <div class="col-md-2 p-0 float-left">
                                    FROM
                                </div>
                                <div class="col-md-10 p-0">
                                    <b style="color:#333333;">{{ user.name }}</b> {{ (user.external_email)? user.external_email:'proposal@followupcrm.com' }}
                                </div>
                            </div>
                            <div v-if="proposalSendType == 'send' && customSigners.length == 0" class="col-md-12 p-0 mt-4 text-muted" style="font-size: 14px;">
                                <div class="col-md-2 p-0 float-left">
                                    TO
                                </div>
                                <div class="col-md-10 p-0 inline-block">
                                    <multiselect v-model="sendForSigningForm.emails"
                                                 id="emailSelected"
                                                 tag-placeholder="Press enter to add"
                                                 placeholder="Add an email to send for signing" label="email" track-by="email"
                                                 :options="options" :multiple="true"
                                                 :taggable="true"
                                                 :close-on-select="false"
                                                 @tag="addEmailForSigning">
                                        <template v-slot:noOptions>
                                            <span style="display:none"> List is empty. </span>
                                        </template>
                                    </multiselect>
                                </div>
                            </div>
                            <div v-if="proposalSendType == 'send' && customSigners.length == 0" class="col-md-12 p-0 mt-4 text-muted" style="font-size: 14px;">
                                <div class="col-md-2 p-0 float-left">
                                    CC
                                </div>
                                <div class="col-md-10 p-0 inline-block">
                                    <multiselect v-model="sendForSigningForm.ccEmails"
                                                 id="ccEmailSelected"
                                                 tag-placeholder="Press enter to add"
                                                 placeholder="Add an email to send for signing"
                                                 :options="options" :multiple="true"
                                                 track-by="email"
                                                 label="email"
                                                 :taggable="true"
                                                 :close-on-select="false"
                                                 @tag="addEmailForSigningCC">
                                        <template v-slot:noOptions>
                                            <span style="display:none"> List is empty. </span>
                                        </template>
                                    </multiselect>
                                </div>
                            </div>
                            <div class="col-md-12 p-0 mt-4 text-muted" style="font-size: 14px;" v-if="customSigners.length == 0">
                                <div class="col-md-2 p-0 float-left">
                                    To View Only
                                </div>
                                <div class="col-md-10 p-0 inline-block">
                                    <multiselect v-model="sendForSigningForm.viewOnlyEmails"
                                                 id="viewOnlyEmailSelected"
                                                 tag-placeholder="Press enter to add"
                                                 placeholder="Add an email to send for viewing"
                                                 :options="options" :multiple="true"
                                                 track-by="email"
                                                 label="email"
                                                 :taggable="true"
                                                 :close-on-select="false"
                                                 @tag="addEmailForSigningViewOnly">
                                        <template v-slot:noOptions>
                                            <span style="display:none"> List is empty. </span>
                                        </template>
                                    </multiselect>
                                </div>
                            </div>
                            <div class="col-md-12 p-0 mt-4 text-muted" v-if="customSigners.length > 0">
                                <div class="col-md-12 p-0 py-1 float-left" style="font-size: 14px;" v-for="(signer, index) in customSigners">
                                    <div class="col-md-2 p-0 float-left text-right pr-2 text-black">
                                        {{index+1}}
                                    </div>
                                    <div class="col-md-10 p-0 inline-block">
                                        <b style="color:#333333;">{{signer.name}}</b> {{signer.email}}
                                    </div>

                                </div>
                            </div>
                        </div>
                        <hr>
                        <div class="p-4" style="padding-top:0 !important;">
                            <div class="col-md-2 p-0 float-left text-muted">
                                Subject
                            </div>
                            <div class="col-md-10 p-0 inline-block">
                                <input type="text" :value="user.name+' sent you '+proposalData.project.name+' proposal'" name="subject" id="subject" class="w-50"><div class="proposal-subject-with-project-id" style="float: right;width: 48%;overflow: auto;text-align: left;background: whitesmoke;padding: 0 10px;font-size: 14px;border-radius: 5px;padding: 10px; margin-right: 10px;" :title="project.name+' - '+project.id"><span style="width: 400px !important; display:block;">({{project.name}} - {{project.id}})</span></div>
                            </div>
                            <div class="col-md-2 p-0 float-left mt-4 text-muted">
                                Message
                            </div>
                            <div class="col-md-10 p-0 inline-block mt-4">
                                <textarea id="emailMessage" style="width: 100%;resize: none;" rows="13" placeholder="Write message to send in email with proposal.">To review this quote, click on the button below.</textarea>
                            </div>
                            <div class="col-md-12 p-0 inline-block mt-4">
                                <button class="btn btn-primary rounded-full float-right"
                                        @click="sendForSigning()">
                                    Send
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="proposal-overlay-document">
            <img :src="proposalLoader" />
            <h1 class="align-center">Generating proposal & sending to client.</h1>
        </div>
    </div>
</template>
<script>


import Form from "../../utils/form";
import Multiselect                    from 'vue-multiselect';
import Swal from "sweetalert2";
import {specialCharacterCodeConstants} from '../constants/constants.js';

let token = document.head.querySelector('meta[name="csrf-token"]');

export default {
    props: ['proposalEmails', 'proposalData', 'user', 'proposalSendType', 'proposalLoader', 'project', 'proposalOriginalId', 'customSigners'],
    components: {Multiselect, specialCharacterCodeConstants},
    data() {
        return {
            sendForSigningForm           : new Form({
                emails: (this.proposalSendType == 'send')? this.proposalEmails:[],
                ccEmails:[],
                viewOnlyEmails:(this.proposalSendType == 'view')? this.proposalEmails:[]
            }),
            options: [],
            senderIp:'',
            specialCharacterCode: specialCharacterCodeConstants
        }
    },
    created(){
        this.getIPFromAmazon();
    },
    mounted() {

    },
    methods: {
        addEmailForSigning(newEmail) {
            var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/;
            if (newEmail.match(mailformat)) {
                const tag = {
                    email: newEmail,
                };
                this.sendForSigningForm.emails.push(tag);
            } else {
                this.fireErrorToast("You have entered an invalid email address!");
            }
        },
        addEmailForSigningCC(newEmail) {
            var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/;
            if (newEmail.match(mailformat)) {
                const tag = {
                    email: newEmail,
                };
                this.sendForSigningForm.ccEmails.push(tag);
            } else {
                this.fireErrorToast("You have entered an invalid email address!");
            }
        },
        addEmailForSigningViewOnly(newEmail) {
            var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/;
            if (newEmail.match(mailformat)) {
                const tag = {
                    email: newEmail,
                };
                this.sendForSigningForm.viewOnlyEmails.push(tag);
            } else {
                this.fireErrorToast("You have entered an invalid email address!");
            }
        },
        backToProposal(){
            window.location.href = "/proposal/"+this.proposalData.id+"/proposal-generator";
        },
        sendForSigning(){
            var emailMessage = $('#emailMessage').val();
            var emailSubjectCustom = $('#subject').val();

            let projectNameSplit = this.project.name.split('');
            let nameArray = [];
            this.specialCharacterCode.forEach(character => {
                projectNameSplit.forEach((item, index) => {
                    if(item == character.character){
                        nameArray.push({index: index, code: character.code});
                    }
                });
            });
            projectNameSplit.forEach((item, index) => {
                nameArray.forEach((character, ind) => {
                    if(index == character.index){
                        projectNameSplit[index] = character.code;
                    }
                })
            });

            let projName = projectNameSplit.join("");

            var emailSubject = emailSubjectCustom+' ('+this.project.name+' - '+this.project.id+')';
            if(emailSubject == ""){
                this.fireErrorToast('Please add email subject.');
                return false;
            }

            if(this.sendForSigningForm.emails.length == 0 && this.sendForSigningForm.viewOnlyEmails.length == 0 && this.customSigners.length == 0){
                this.fireErrorToast('Please add an email.');
                return false;
            }
            $('.proposal-overlay-document').show();
            this.proposalData.message = emailMessage;
            this.proposalData.emailSubject = emailSubject;
            this.proposalData.userEmails = this.sendForSigningForm.emails;
            this.proposalData.ccEmails = this.sendForSigningForm.ccEmails;
            this.proposalData.viewOnlyEmails = this.sendForSigningForm.viewOnlyEmails;
            this.proposalData.sendType = this.proposalSendType;
            this.proposalData.signers = this.customSigners;
            const proposal = {
                proposal:this.proposalData,
                senderIp: this.senderIp,
                proposalId: this.proposalOriginalId,
                userTimeZoneName: Intl.DateTimeFormat().resolvedOptions().timeZone,
                userTimeZoneOffset: new Date().getTimezoneOffset(),
            };
            axios.post('/proposal/' + this.proposalData.id + '/proposal-generator/send-for-signing', proposal).then(
                (response) => {
                    $('.proposal-overlay-document').hide();
                    this.fireSuccessToast(response.data.message);
                    this.getBackToProposal();
                }
            );
        },
        fireSuccessToast(message) {
            const Toast = Swal.mixin({
                toast            : true,
                position         : 'top-end',
                showConfirmButton: false,
                timer            : 2000
            });

            Toast.fire({
                type : 'success',
                title: message,
            });
        },
        fireErrorToast(message) {
            const Toast = Swal.mixin({
                toast            : true,
                position         : 'top-end',
                showConfirmButton: false,
                timer            : 2000
            });

            Toast.fire({
                type : 'error',
                title: message,
            });
        },
        getBackToProposal(){
            var proposalId = this.proposalData.id;
            setTimeout(
                function(){
                    window.location.href = "/proposal/"+proposalId+"/proposal-generator";
                }, 2000
            );
        },
        getIPFromAmazon() {
            fetch('https://api.ipify.org?format=json')
                .then(x => x.json())
                .then(({ ip }) => {
                    this.senderIp = ip;
                });
        }
    }
}
</script>
<style lang="scss" scoped>
   textarea{
       border: none;
       overflow: auto;
       outline: none;
       -webkit-box-shadow: none;
       -moz-box-shadow: none;
       box-shadow: none;
       resize: none;
       background: #f7f7f7;
       padding: 10px;
   }
   #subject{
       border: none;
       overflow: auto;
       outline: none;
       -webkit-box-shadow: none;
       -moz-box-shadow: none;
       box-shadow: none;
       resize: none;
       border-bottom: 1px solid #f5f5f5;
       padding: 10px 0 10px 0;
   }
   .proposal-overlay-document{
       position: fixed;
       display: none;
       width: 100%;
       height: 100%;
       top:18px;
       left: 0;
       right: 0;
       bottom: 0;
       //background-color: rgba(0,0,0,0.5);
       z-index: 999;
       cursor: pointer;
       background: #ffffffd9;
   }
   .proposal-overlay-document img{
       position: absolute;
       right: 42%;
       top: 28%;
   }
   .proposal-overlay-document h1{
       position: absolute;
       color: #01b1af;
       top: 60%;
       right: 30%;
       font-weight: 200;
   }
   .proposal-subject-with-project-id::-webkit-scrollbar {
       display: none;
   }
</style>
